/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { AdditionalWorkListAdmin } from './AdditionalWorkListAdmin'
import {
  AdditionalWorkListAdminFromJSON,
  AdditionalWorkListAdminFromJSONTyped,
  AdditionalWorkListAdminToJSON,
} from './AdditionalWorkListAdmin'

/**
 *
 * @export
 * @interface PaginatedAdditionalWorkListAdmin
 */
export interface PaginatedAdditionalWorkListAdmin {
  /**
   *
   * @type {Array<AdditionalWorkListAdmin>}
   * @memberof PaginatedAdditionalWorkListAdmin
   */
  results: Array<AdditionalWorkListAdmin>
  /**
   *
   * @type {number}
   * @memberof PaginatedAdditionalWorkListAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedAdditionalWorkListAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedAdditionalWorkListAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedAdditionalWorkListAdmin interface.
 */
export function instanceOfPaginatedAdditionalWorkListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedAdditionalWorkListAdminFromJSON(
  json: any,
): PaginatedAdditionalWorkListAdmin {
  return PaginatedAdditionalWorkListAdminFromJSONTyped(json, false)
}

export function PaginatedAdditionalWorkListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedAdditionalWorkListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(AdditionalWorkListAdminFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedAdditionalWorkListAdminToJSON(
  value?: PaginatedAdditionalWorkListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(AdditionalWorkListAdminToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
